import React from 'react';
import styled from 'styled-components/macro';
import { Paragraph } from './typography';

const Container = styled.div`
  width: 100%;
  text-align: center;
`;
const Title = styled(Paragraph)`
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  color: ${({ theme }) => theme.colors.colorBlue};

  @media (max-width: 1199px){
    font-size: 15px;
  }
`;

const ColumnContainer = styled.div`
  width: 100%;
  max-width: 210px;
  display: inline-block;
  clear: both;
`;

const TextContainer = styled.div`
  height: 250px;
  width: 100vw;
  position: relative;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  color: ${({
    flaskeWhite,
    kartonWhite,
    flaske,
    karton,
    theme,
  }) => {
    if (flaskeWhite || kartonWhite) {
      return 'white';
    }
    if (flaske) {
      return theme.colors.colorBlue;
    }
    if (karton) {
      return theme.colors.colorRed;
    }
    return '';
  }};
`;
const Text1 = styled.span`
  font-size: 16px;

  @media (max-width: 1199px) {
    font-size: 14px;
  }

  @media (max-width: 991px) {
    font-size: 18px;
  }
`;
const Text2 = styled.span`
  font-size: 26px;

  @media (max-width: 1199px) {
    font-size: 22px;
  }

  @media (max-width: 991px) {
    font-size: 26px;
  }
`;
const BarBackground = styled.div`
  @keyframes slideFromBottom {
    0% {
      transform: translateY(100%);
    }
    100% {
      transform: translateY(0);
    }
  }
  position: absolute;
  bottom: 0px;
  width: 100%;
  animation: 1.5s ease-out 0s 1 slideFromBottom; /* Time Animation Delay Cycles Keyframe */
  background: ${({ theme, flaske }) => (flaske ? theme.colors.colorBlue : theme.colors.colorRed)};
  height: ${({
    flaskeProcent,
    kartonProcent,
    flaske,
    karton,
  }) => {
    if (flaske) {
      return flaskeProcent;
    }
    if (karton) {
      return kartonProcent;
    }
    return 'xx';
  }}%;
`;
const ColumnNoStyle = ({
  flaskeProcent,
  kartonProcent,
  indikator,
  flaske,
  karton,
  flaskeWhite,
  kartonWhite,
  ...otherProps
}) => (
  <div {...otherProps}>
    {flaske && (
      <React.Fragment>
        <BarBackground flaske flaskeProcent={flaskeProcent} />
        <TextContainer flaskeWhite={flaskeWhite} flaske>
          <Text1>FLASKE</Text1><br />
          <Text2>{flaskeProcent}{indikator}</Text2>
        </TextContainer>
      </React.Fragment>
    )}
    {karton && (
      <React.Fragment>
        <BarBackground karton kartonProcent={kartonProcent} />
        <TextContainer kartonWhite={kartonWhite} karton>
          <Text1>KARTON</Text1><br />
          <Text2>{kartonProcent}{indikator}</Text2>
        </TextContainer>
      </React.Fragment>
    )}
  </div>
);
const Column = styled(ColumnNoStyle)`
  width: 48%;
  max-width: 100px;
  height: 250px;
  background: ${({ theme }) => theme.colors.colorGreyLightAlt};
  position: relative;
  overflow: hidden;
  ${({
    flaske,
    karton,
  }) => {
    if (flaske) {
      return `
        float: left;
      `;
    }
    if (karton) {
      return `
        float: right;
      `;
    }
    return '';
  }}
`;

export default ({
  title,
  flaskeProcent,
  kartonProcent,
  indikator,
  flaskeWhite,
  kartonWhite,
}) => (
  <Container>
    <Title>{title} ({indikator})</Title>
    <ColumnContainer>
      <Column flaskeWhite={flaskeWhite} kartonWhite={kartonWhite} flaskeProcent={flaskeProcent} kartonProcent={kartonProcent} indikator={indikator} flaske />
      <Column flaskeWhite={flaskeWhite} kartonWhite={kartonWhite} flaskeProcent={flaskeProcent} kartonProcent={kartonProcent} indikator={indikator} karton />
    </ColumnContainer>
  </Container>
);
